import {ReportMetric} from './report-metric.enum';
import {ReportDimension} from './report-dimension.enum';
import {ReportPredicate} from './report-predicate.model';
import {ReportGrouping} from './report-grouping.enum';
import {ReportFilter} from './report-filter.model';
import {ReportDataSource} from './report-data-source.enum';
import {ReportType} from './report-type.enum';
export class ReportRequest {
  reportType?: ReportType = ReportType.FINANCIAL;
  reportGrouping?: ReportGrouping = ReportGrouping.COMBINED;
  metrics?: ReportMetric[];
  dimensions?: Object[];
  predicates?: ReportPredicate[];
  filters?: ReportFilter;
  dataSource?: ReportDataSource = ReportDataSource.DATE_PERIOD_DEPENDENT;
}
